import { GirderUpdatesProvider } from '../contexts/GirderUpdatesContext';
import ConfigGuard from './ConfigGuard';
import { useOutlet } from 'react-router-dom';

/**
 * Wrapper component that provides GirderUpdatesContext and ConfigGuard
 */
export default function GirderUpdatesWrapper() {
  const outlet = useOutlet();
  
  return (
    <GirderUpdatesProvider>
      <ConfigGuard />
    </GirderUpdatesProvider>
  );
}
